import {Title} from './styles/ic-tools.styled'

interface IcToolsProps {
    smallSize?: boolean
}
export function IcTools({smallSize = false}: IcToolsProps): JSX.Element {
    return <Title smallSize={smallSize}>Incus Communicator Tools</Title>
}
